const PREFERENCES_ENTRY_TELEMETRY_KEY = "mincool.preferencesEntryTelemetry";

function canUseWindow() {
  return typeof window !== "undefined";
}

export function storePreferencesEntryTelemetry(payload) {
  if (!canUseWindow() || !payload || typeof payload !== "object") {
    return;
  }
  window.sessionStorage.setItem(PREFERENCES_ENTRY_TELEMETRY_KEY, JSON.stringify(payload));
}

export function peekPreferencesEntryTelemetry() {
  if (!canUseWindow()) {
    return null;
  }
  const raw = window.sessionStorage.getItem(PREFERENCES_ENTRY_TELEMETRY_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function consumePreferencesEntryTelemetry() {
  if (!canUseWindow()) {
    return null;
  }
  const raw = window.sessionStorage.getItem(PREFERENCES_ENTRY_TELEMETRY_KEY);
  if (!raw) {
    return null;
  }
  window.sessionStorage.removeItem(PREFERENCES_ENTRY_TELEMETRY_KEY);
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
